import { useState, useEffect } from "react";
import axios from "axios";
import ProductCard from "./ProductCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ProductGrid({ limit, category = "all" }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const params = category !== "all" ? `?category=${category}` : "";
        const res = await axios.get(`${API}/products${params}`);
        const data = limit ? res.data.slice(0, limit) : res.data;
        setProducts(data);
      } catch (err) {
        console.error("Failed to fetch products:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [category, limit]);

  if (loading) {
    return (
      <div
        data-testid="product-grid-loading"
        className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-8 sm:gap-x-6 sm:gap-y-12"
      >
        {[...Array(limit || 8)].map((_, i) => (
          <div key={i} className="animate-pulse">
            <div className="bg-[#F3F3F3] aspect-[3/4] mb-4" />
            <div className="h-3 bg-[#F3F3F3] w-3/4 mb-2" />
            <div className="h-3 bg-[#F3F3F3] w-1/3" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div
      data-testid="product-grid"
      className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-8 sm:gap-x-6 sm:gap-y-12"
    >
      {products.map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  );
}
